import { render, staticRenderFns } from "./AcademyLayout.vue?vue&type=template&id=0279e43d&scoped=true&lang=pug&"
import script from "./AcademyLayout.vue?vue&type=script&lang=ts&"
export * from "./AcademyLayout.vue?vue&type=script&lang=ts&"
import style0 from "./AcademyLayout.vue?vue&type=style&index=0&id=0279e43d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0279e43d",
  null
  
)

export default component.exports